import {Component} from '@angular/core';
import {CommonService} from '../../../services/common.service';
import {UserService} from '../../../services/user.service';

@Component({
    selector: 'my-orders',
    templateUrl: 'app.component.html',
    styleUrl: 'app.component.scss',
    standalone: false
})
export class OrdersComponent {
  public orders;
  public loading: boolean;

  constructor(
    protected userService: UserService,
    public commonService: CommonService
  ) {
    this.loading = true;

    this.userService.getUserOrders().then(({data}) => {
      this.orders = data.orders;
      this.loading = false;
    });
  }

  public navigate(path) {
    this.commonService.navigate(path);
  }
}
